module.exports = __webpack_public_path__ + "static/media/article2.16076d89.webp";